/* Section-scoped behavior; custom element lifecycle also covers Theme Editor reloads. */
(() => {
  if (customElements.get('sudora-header')) return;

  class SudoraHeader extends HTMLElement {
    connectedCallback() {
      // A section may be reconnected by the Theme Editor.
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.drawer = this.querySelector('.ch-m-drawer');
      this.opener = this.querySelector('[data-ch-open]');
      this.desktopMenus = [...this.querySelectorAll('.ch-desktop-wrapper details')];
      this.mobileQuery = window.matchMedia('(max-width: 990px)');

      this.desktopMenus.forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (!menu.open) return;
          this.desktopMenus.forEach((other) => { if (other !== menu) other.open = false; });
          const panel = menu.querySelector(':scope > .ch-dropdown-content');
          if (!panel) return;
          panel.style.transform = '';
          const bounds = panel.getBoundingClientRect();
          const edge = document.documentElement.clientWidth - 12;
          const offset = bounds.right > edge ? edge - bounds.right : bounds.left < 12 ? 12 - bounds.left : 0;
          if (offset) panel.style.transform = `translateX(${offset}px)`;
        }, options);
      });
      this.opener?.addEventListener('click', () => this.openDrawer(), options);
      this.querySelector('[data-ch-close]')?.addEventListener('click', () => this.closeDrawer(), options);
      this.drawer?.addEventListener('close', () => this.releaseDrawer(), options);
      this.drawer?.addEventListener('click', (event) => {
        const bounds = this.drawer.getBoundingClientRect();
        if (event.target === this.drawer &&
          (event.clientX < bounds.left || event.clientX > bounds.right ||
           event.clientY < bounds.top || event.clientY > bounds.bottom)) this.closeDrawer();
        if (event.target.closest('a[href]')) this.closeDrawer();
      }, options);
      this.mobileQuery.addEventListener('change', () => {
        if (!this.mobileQuery.matches) this.closeDrawer(false);
        this.closeDesktopMenus();
      }, options);
      document.addEventListener('click', (event) => {
        this.desktopMenus.forEach((menu) => {
          if (!menu.contains(event.target)) menu.open = false;
        });
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || this.drawer?.open) return;
        const openMenu = this.desktopMenus.find((menu) => menu.open && menu.contains(event.target));
        if (openMenu) {
          event.preventDefault();
          openMenu.open = false;
          openMenu.querySelector('summary')?.focus();
        }
      }, options);
      this.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.desktopMenus.forEach((menu) => {
            if (!menu.contains(document.activeElement)) menu.open = false;
          });
        });
      }, options);
    }

    openDrawer() {
      if (!this.drawer || this.drawer.open || !this.mobileQuery.matches) return;
      this.closeDesktopMenus();
      this.returnFocus = document.activeElement;
      this.previousOverflow = document.body.style.overflow;
      this.drawer.showModal(); // Native dialog traps focus and makes the background inert.
      document.body.style.overflow = 'hidden';
      this.opener?.setAttribute('aria-expanded', 'true');
    }

    closeDrawer(restoreFocus = true) {
      if (!this.drawer?.open) return;
      this.restoreFocus = restoreFocus;
      this.drawer.close();
      this.releaseDrawer();
    }

    releaseDrawer() {
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      this.opener?.setAttribute('aria-expanded', 'false');
      if (this.restoreFocus !== false && this.returnFocus?.isConnected && this.mobileQuery.matches) {
        this.returnFocus.focus({ preventScroll: true });
      }
      this.returnFocus = null;
      this.restoreFocus = true;
    }

    closeDesktopMenus() { this.desktopMenus?.forEach((menu) => { menu.open = false; }); }

    disconnectedCallback() {
      this.closeDrawer(false);
      this.releaseDrawer();
      this.listeners?.abort();
    }
  }

  customElements.define('sudora-header', SudoraHeader);
})();
